import { select, put, call, all } from 'redux-saga/effects';
import { getSkuPricing } from '../../api/skuMapperApi';
import { updateProductInfo } from '../../actions/pricingActions';
import { configSelector, configuratorSelector } from '../../selectors';
import getThdProductDetailsOrNotItsCool from './_getThdProductDetailsOrNotItsCool';
import { getPriceData } from './_utils';

function* getSOPricing(skuMap, storeNumber) {
  const { sku, skuType } = skuMap;
  const { partnerProductId } = yield select(configSelector);
  const { productInfo } = yield select(configuratorSelector);

  const { productId } = productInfo;

  const [skuPrice, thdDetails] = yield all([
    call(getSkuPricing, sku, skuType, productId),
    call(getThdProductDetailsOrNotItsCool, [partnerProductId], storeNumber),
  ]);

  const newSkus = {
    ...skuMap,
    sku: partnerProductId.toString(),
  };

  yield put(updateProductInfo({
    newSkus,
    thdDetails,
    skuPrice,
  }));

  return getPriceData(skuPrice.price, skuPrice.specialPrice);
}

export default getSOPricing;
